import { Phone } from "lucide-react";
import { CONTACT } from "../content";
import { useEnquiry } from "../enquiryContext";

export default function StickyCTA() {
  const { openPopup } = useEnquiry();
  return (
    <div data-testid="sticky-cta" className="fixed bottom-0 left-0 right-0 z-50 md:hidden grid grid-cols-2 border-t border-gold/30">
      <a
        data-testid="sticky-call-button"
        href={CONTACT.phoneHref}
        className="flex items-center justify-center gap-2 bg-ink text-[#F9F8F6] py-4 text-[12px] font-semibold uppercase tracking-[0.18em]"
      >
        <Phone size={15} strokeWidth={1.75} /> Call Now
      </a>
      <button
        data-testid="sticky-enquire-button"
        onClick={() => openPopup({ intent: "Get Cost Sheet" })}
        className="bg-gold text-ink py-4 text-[12px] font-semibold uppercase tracking-[0.18em]"
      >
        Get Cost Sheet
      </button>
    </div>
  );
}
